import type {DependencyList} from "react";
import { useEffect, useRef, useState} from "react";
import {useCallbackRef} from './useCallbackRef'

// https://codereview.stackexchange.com/questions/247410/react-hook-useasyncvalue/279208#279208
// See also `usePromise`
export default function useAsyncValue<T>(cb: () => Promise<T>, deps?: DependencyList): T | undefined {
    const [value, setValue] = useState<T | undefined>(undefined)
    const nonce = useRef(Symbol())
    const cbRef = useCallbackRef(cb)

    useEffect(() => {
        const current = nonce.current = Symbol()

        Promise.resolve(cbRef.current()).then(result => {
            if (nonce.current === current) {
                setValue(result)
            }
        })

        return () => {
            nonce.current = Symbol()
        }
    }, deps)

    return value
}
